<div class="workersDisplay" #outerElement [class.showCiCoIcon]="showCiCoTypeIcon()">
  @if (showAbsent && (visibleWorkers$ | async)?.length > 0) {
    <p>{{'ABSENT_WORKERS' | translate}}</p>
  }
  <mat-grid-list cols="{{columns}}" gutterSize="10">
    @for (worker of visibleWorkers$ | async; track worker) {
      <mat-grid-tile class="workerGrid dialog" [@workerState]="getAnimationState(worker)"
        [colspan]="1" (click)="openWorkerInfo(worker)" [ngClass]="getCICOTypeClass(worker)">
        @if (getShowImageSetting() && worker.userImage.safeSrc) {
          <img class="workerPortrait" [src]="worker.userImage.safeSrc">
        }
        @if (appService.getInterfaceAttendanceDetailed() && worker._apiData.currentcicotyp) {
          <img class="attIcon"
            [alt]="appService.getCiCoIconTitle(worker)"
            [title]="appService.getCiCoIconTitle(worker)"
            [style.background-color]="appService.getCiCoIconColor(worker)"
            [src]="appService.getCiCoIcon(worker)">
        }
        <div [class.workerName]="getShowImageSetting()">
          {{worker.apiData.caption}}
        </div>
      </mat-grid-tile>
    }
    @if (overflowNumber > 0) {
      <mat-grid-tile class="workerGrid dialog" [colspan]="1" (click)="openWorkerList()">
        <div>
          +{{overflowNumber}}
        </div>
      </mat-grid-tile>
    }
  </mat-grid-list>
</div>
